export const SET_DATA = 'SET_DATA';
export const SET_SORT_KEY = 'SET_SORT_KEY';
export const SET_SORT_INDEX = 'SET_SORT_INDEX';
export const SET_SORT_TYPE = 'SET_SORT_TYPE';
export const SET_COMPRESSED = 'SET_COMPRESSED';
export const SET_LOCAL_ID_GRID_CONFIG_ITEM = 'SET_LOCAL_ID_GRID_CONFIG_ITEM';
export const SET_SORTED_DATA = 'SET_SORTED_DATA';
export const UPDATE_CONFIGS = 'UPDATE_CONFIGS';
export const UPDATE_IMPORT_CONFIGS = 'UPDATE_IMPORT_CONFIGS';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const SET_TRANSPOSE = 'SET_TRANSPOSE';
export const SET_TRANSPOSE_LOADING = 'SET_TRANSPOSE_LOADING';
export const SET_SELECTED_LIST = 'SET_SELECTED_LIST';
export const SET_IS_EDITABLE = 'SET_IS_EDITABLE';
export const SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS = 'SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS';
